<template>
    <form action="" class="row">
        <div v-if="user" class="card-header" role="alert">
            <h1 class="card-title">{{ user.type.first_name }} {{ user.type.last_name }}</h1>
            <h4 class=""><strong>{{ $t('Organization') }}: </strong> <span v-if="user.type.org == null">{{ $t('N/A') }} </span><span v-else><a
                :href="'/orgs/' + user.type.org_id">{{ user.type.org.name ? user.type.org.name : $t("N/A") }} </a></span>
            </h4>
            <h1 v-if="isEditModeOn" class="page-header-title">
            </h1>
            <div v-if="user.type.location" class="d-flex flex-column">
                <h5 class="fw-bold card-text">
                    Location: {{ user.type.location.name }} <i
                    v-if="user.type.org.primary_location_id === user.type.location.id"
                    class="bi-star text-secondary me-1"></i>
                </h5>
                <span class="card-text">{{ user.type.location.address1 }}, <br/>{{
                        user.type.location.city
                    }}, {{ user.type.location.state }} ,{{ user.type.location.zip }}</span>
            </div>

        </div>
        <div class="card-group">
            <!-- Card -->
            <div class="card col-md-6">
                <div class="card-header">
                    <h3 class="card-header-title">{{ $t('User Information') }}</h3>
                </div>
                <div class="card-body">
                    <fieldset>
                        <div class="col-md-12">
                            <div class="mb-3 col-md-6">
                                <label class="fs-6 mb-0 --form-label --mb-1" for="user-show-name">{{ $t('Username') }}</label>
                                <input :placeholder="$t('N/A')" class="form-control form-control-sm" v-model="user.name"
                                       name="name" id="user-show-name"/>
                            </div>
                            <div class="mb-3 col-md-6">
                                <label class="fs-6 mb-0 --form-label --mb-1" for="first_name">{{ $t('First Name') }}</label>
                                <input :placeholder="$t('N/A')" class="form-control form-control-sm"
                                       v-model="user.type.first_name" name="first_name" id="first_name"/>
                            </div>
                            <div class="mb-3 col-md-6">
                                <label class="fs-6 mb-0 --form-label --mb-1" for="last_name">{{ $t('Last Name') }}</label>
                                <input :placeholder="$t('N/A')" class="form-control form-control-sm"
                                       v-model="user.type.last_name" name="last_name" id="last_name"/>
                            </div>
                            <div class="mb-3 col-md-6">
                                <label class="fs-6 mb-0 --form-label --mb-1" for="email">{{ $t('Email') }}</label>
                                <input :placeholder="$t('N/A')" class="form-control form-control-sm" v-model="user.type.email"
                                       name="email" id="email"/>
                            </div>
                            <div class="mb-3 col-md-6">
                                <label class="fs-6 mb-0 --form-label --mb-1" for="phone">{{ $t('Phone') }}</label>
                                <input :placeholder="$t('N/A')" class="form-control form-control-sm" v-model="user.type.phone"
                                       name="phone" id="phone"/>
                            </div>
                            <div class="mb-3 col-md-6">
                                <label class="fs-6 mb-0 --form-label --mb-1" for="email">{{ $t('User Type/Role') }}</label>
                                <input :placeholder="$t('N/A')" class="form-control form-control-sm" v-model="user.role"
                                       name="role" id="role"/>
                            </div>
                            <div class="mb-3 col-md-6">
                                <label class="fs-6 mb-0 --form-label --mb-1" for="email">{{ $t('Alert Type') }}</label>
                                <div class="d-block btn-group btn-group-sm" role="group" aria-label="Basic example">
                                    <button
                                        type="button"
                                        @click="user.notification_type = 'Email'"
                                        :class="`btn btn${user.notification_type == 'Email' ? '' : '-outline'}-primary`"
                                    >
                                        {{ $t('Email') }}
                                    </button>
                                    <button type="button" @click="user.notification_type = 'Text'"
                                            :class="`btn btn${user.notification_type == 'Text' ? '' : '-outline'}-primary`">
                                        {{ $t('Text') }}
                                    </button>
                                </div>
                            </div>
                            <div class="mb-3 col-md-12">
                                <label class="fs-6 mb-0 --form-label --mb-1" for="active">{{ $t('User Status') }}</label>
                                <div class="form-check form-switch form-switch-between mb-4">
                                    <label class="form-check-label">{{ $t('Disabled') }}</label>
                                    <input type="checkbox" class="form-check-input" v-model="user.active" name="active"
                                           id="active" :checked="user.active">
                                    <label class="form-check-label">{{ $t('Enabled') }}</label>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
            <div class="card col-md-6">
                <div class="card-header">
                    <h3 class="card-header-title">{{ $t('Groups and Locations') }}</h3>
                </div>
                <div class="card-body">
                    <fieldset>
                        <div class="mb-3 col-md-12">
                            <label class="fs-6 mb-0 --form-label --mb-1" for="active">{{ $t('Select a Location') }}</label>
                            <VueMultiselect
                                v-model="user.type.org_location_id"
                                :options="locations"
                                :multiple="false"
                                :searchable="true"
                                label="Location"
                                track-by="id"
                            >
                            </VueMultiselect>
                        </div>
                    </fieldset>
                </div>
                <div class="card-footer">
                    <button type="button" @click="saveUser" id="saveUser" class="btn btn-primary"><span
                        v-if="isLoadingUser" :disabled="isLoadingUser">
    <i class="fa fa-spinner fa-spin"></i> {{ $t('Loading') }}...
  </span>
                        <span v-else>
    {{ $t('Save User') }}
  </span></button>
                </div>
            </div>
        </div>
        <div class="card-group">
            <div class="card col-md-12">
                <div class="card-header">
                    <h3 class="card-header-title">{{ $t('Edit Password') }}</h3>
                </div>
                <div class="card-body">
                    <fieldset>
                        <!-- Passwords section -->
                        <div class="row">
                            <div class="mb-3 col-md-12">
                                <label class="fs-6 mb-0 --form-label --mb-1" for="current_password">{{ $t('Current Password') }}</label>
                                <input type="password" class="form-control form-control-sm"
                                       v-model="user.current_password" name="current_password" id="current_password"/>
                            </div>
                            <div class="mb-3 col-md-6">
                                <label class="fs-6 mb-0 --form-label --mb-1" for="new_password">{{ $t('New Password') }}</label>
                                <input type="password" class="form-control form-control-sm" v-model="user.password"
                                       name="password" id="password"/>
                            </div>
                            <div class="mb-3 col-md-6">
                                <label class="fs-6 mb-0 --form-label --mb-1" for="confirm_password">{{ $t('Confirm Password') }}</label>
                                <input type="password" class="form-control form-control-sm"
                                       v-model="user.password_confirmation" name="password_confirmation"
                                       id="password_confirmation"/>
                            </div>
                        </div>
                        <!-- End of Passwords section -->
                    </fieldset>
                </div>
                <div class="card-footer">
                    <button type="button" @click="saveUserPassword" id="saveUserPassword" class="btn btn-primary"
                            :disabled="isLoadingPassword">
                    <span v-if="isLoadingPassword">
    <i class="fa fa-spinner fa-spin"></i> {{ $t('Loading') }}...</span>
                        <span v-else>
                            {{ $t('Update Password') }}
                          </span>
                    </button>
                </div>
            </div>
        </div>
        <!-- End Card -->
    </form>
    <!-- Accordion -->
    <div class="accordion" id="accordionExample">
        <div class="accordion-item">
            <div class="accordion-header" id="headingOne">
                <a class="accordion-button" role="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                   aria-expanded="false" aria-controls="collapseOne">
                    {{ $t('User Login History') }}
                </a>
            </div>
            <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                 data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    <LoginHistory
                        :user_id="id"
                    ></LoginHistory>
                </div>
            </div>
        </div>
    </div>
    <!-- End Accordion -->
</template>

<script>
import {trans as $t} from "@/vue/composables/missingTranslations";
import LoginHistory from './LoginHistory.vue';
import {toast} from "vue3-toastify";
import VueMultiselect from 'vue-multiselect';

export default {

    components: {
        LoginHistory,
        VueMultiselect
    },
    props: {
        id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            user: {
                type: {},
                modelType: 'staff',
            },
            locations: [],
            notification_type: "Text",
            loaded: false,
            isEditModeOn: false,
            isLoadingUser: false,
            isLoadingGroupsLocations: false,
            isLoadingPassword: false,
        };
    },
    methods: {
        load: function () {
            axios
                .get("/api/users/" + this.id, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then((response) => {
                    this.user = response.data;
                    this.$emit("loaded", true);
                    if (this.refresh) this.$emit("refreshed", true);
                    this.loaded = true;
                })
                .catch((error) => {
                    this.loaded = false;
                    this.$emit("load-error", error);
                });

            axios.get(`/api/orgs/${this.user.org_id}/locations/`, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then((response) => {
                this.locations = response.data;
            })
                .catch((error) => {
                    this.$emit("load-error", error);
                });
        },
        async saveUser() {
            this.isLoadingUser = true;
            await axios.patch('/api/users/' + this.id, this.user)
                .then(response => {
                    if (response.status === 201 || response.status === 200) {
                        this.displayToast(true, $t("User successfully updated"));
                    } else {
                        this.displayToast(false, response.response.data.result);
                    }
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        async saveUserPassword() {
            this.isLoadingPassword = true;
            await axios.patch('/api/users/' + this.id, this.user)
                .then(response => {
                    if (response.status === 201 || response.status === 200) {
                        this.displayToast(true, $t("Password successfully updated"));
                    } else {
                        this.displayToast(false, response.response.data.message);
                    }
                })
                .catch(error => {
                    this.$emit('save-user-error', error);
                    console.error(error);
                })
                .finally(() => {
                    this.isLoadingPassword = false;
                });
        },
        saveOrg() {
            this.saveUser();
            this.toggleEditMode();
        },
        toggleEditMode() {
            this.isEditModeOn = !this.isEditModeOn;
        },
        updateOrgValue(value) {
            this.user.type.org_id = value;
        },
        displayToast(success, msg) {
            if (success) {
                toast.success(msg, {
                    position: 'bottom-center'
                });
            } else {
                toast.error(msg, {
                    position: 'bottom-center'
                });
            }
        }
    },
    watch: {
        id() {
            this.loaded = false;
            if (this.id > 0) {
                this.load();
            }
        }
    },
    mounted() {
        if (this.id > 0) {
            this.load();
        }
    }
};
</script>

<style scoped>
#saveUser {
    float: right;
}

#saveUserPassword {
    float: right;
}

#current_password {
    width: 50%;
}

#saveGroupLocation {
    float: right;
}
</style>
